// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview[data-v-749b9062]{width:min(888px,100%);background:#fff;box-shadow:0 0 1px rgba(12,14,25,.24),0 2px 6px rgba(17,24,61,.08);border-radius:6px;margin-bottom:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
